import { initAnalytics, trackEvent, trackPage, pagePath } from '../../../analytics/index.js';
export { trackEvent };

let listening = false;
export function startAnalytics() {
  initAnalytics('website');
  trackPage();
  if (listening) return;
  listening = true;
  // Delegation includes gallery cards and controls rendered after page load.
  document.addEventListener('click', (event) => {
    const target = event.target.closest('a, button');
    if (!target || target.disabled) return;
    const source = target.closest('dialog') ? 'dialog' : target.closest('header') ? 'header'
      : target.closest('footer') ? 'footer' : 'content';
    if (target.matches('a[href]')) {
      const url = new URL(target.href, window.location.origin);
      if (url.origin !== window.location.origin) {
        trackEvent('outbound_link', { source });
      } else {
        const destination = pagePath(url.href);
        trackEvent(destination === '/app/signup' ? 'sign_up_cta' : destination === '/gallery/pattern' ? 'select_pattern' : 'navigate', { source, destination });
      }
    } else if (target.matches('[data-download-toggle]')) trackEvent('open_download_menu');
    else if (target.matches('[data-like]')) trackEvent('toggle_pattern_like');
    else if (target.matches('[data-format]')) trackEvent('select_paper_size', { paper_size: target.dataset.format });
    else if (target.matches('[data-close-dialog]')) trackEvent('close_sign_in');
    else if (target.matches('#menu-toggle')) trackEvent('toggle_menu');
    else if (target.closest('#feature-dots') || target.matches('#feature-prev, #feature-next')) trackEvent('view_feature');
    else if (target.closest('#pattern-thumbnails')) trackEvent('view_pattern_photo');
  });
  document.addEventListener('submit', (event) => {
    if (event.target.id === 'hero-register') trackEvent('sign_up_cta', { source: 'hero' });
  });
}
